if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.quantityBreaks = document.getElementById(`quantity-breaks-${this.dataset.sectionId}`);
        this.customFields = document.querySelectorAll(`[id^='CustomField-${this.dataset.sectionId}-']`);
        this.variantInputs = this.form.querySelector(".product-form__variants");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.adding || this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        let hasVariants = false;
        if (this.quantityBreaks && this.variantInputs && this.quantityBreaks.formVariants?.length > 0) {
          let quantityInputs = "";
          hasVariants = true;
          for (let i = 0; i < this.quantityBreaks.formVariants.length; i++) {
              let variant = this.quantityBreaks.formVariants[i];
              quantityInputs += `<input type="hidden" name="items[${i}][quantity]" value="${variant.quantity}">`;
              quantityInputs += `<input type="hidden" name="items[${i}][id]" value="${variant.id}">`;
              this.customFields.forEach(field => {
                  quantityInputs += `<input type="hidden" name="items[${i}][properties][${field.fieldName}]" value="${field.value}">`;
              });
          }
          this.variantInputs.innerHTML = quantityInputs;
        }
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        if (hasVariants) {
          let options = this.dataset.options ? this.dataset.options.split(",") : [];
          let fieldsToDelete = ["id", "quantity", ...options];
          for (let field of fieldsToDelete) {
              formData.delete(field);
          }
        }
        config.body = formData;
        this.skipCart = false;
        if (this.form.querySelector("[type=submit]").dataset.skipCart === "true") {
          this.skipCart = true;
        }

        // One add at a time: also blocks the sticky add-to-cart button, which submits this same form.
        this.adding = true;
        this.toggleBusy(true);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) =>
            response
              .json()
              .catch(() => ({ status: response.status, description: window.cartStrings?.error }))
              .then((data) => (response.ok || data.status ? data : { ...data, status: response.status }))
          )
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description || response.message || this.addErrorText());

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            } else if (this.skipCart) {
              window.location = '/checkout';
              return;
            }

            this.error = false;
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });

            // The item IS in the cart now. If the drawer can't be brought up to date, send the
            // shopper to the cart page rather than showing a drawer that looks empty.
            const render = () =>
              Promise.resolve(this.cart.renderContents(response)).catch((e) => {
                console.error(e);
                window.location = window.routes.cart_url;
              });
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => setTimeout(render), { once: true });
              quickAddModal.hide(true);
              return;
            }
            return render();
          })
          .catch((e) => {
            // Network failure or unreadable response: nothing to show in the drawer, so say so here.
            console.error(e);
            this.handleErrorMessage(this.addErrorText());
          })
          .finally(() => {
            this.adding = false;
            this.toggleBusy(false);
          });
      }

      toggleBusy(busy) {
        const buttons = [this.submitButton, document.getElementById(`StickyAtcSubmitButton-${this.dataset.sectionId}`)].filter(Boolean);
        buttons.forEach((button) => {
          button.classList.toggle('loading', busy);
          button.toggleAttribute('aria-busy', busy);
          if (busy) button.setAttribute('aria-disabled', true);
          else if (!this.error) button.removeAttribute('aria-disabled');
          const spinner = button.querySelector('.loading__spinner, .loading-overlay__spinner');
          if (spinner) spinner.classList.toggle('hidden', !busy);
        });
      }

      addErrorText() {
        return "Sorry, we couldn't add this to your cart. Please check your connection and try again.";
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
